export default __webpack_public_path__ + "static/media/assistansbolaget.029ff416.png";